import './addButton.less';
import classnames from 'classnames';
import { AntButton } from 'controls/react/ant/antButton';
import { PlusCircleOutlined } from '@ant-design/icons';
import React from 'react';
import { observer } from 'mobx-react';

export type AddButtonProps = {
	label: string;
	onClick: () => void;
	disabled?: boolean;
	containerClass?: string;
};
export const AddButton = observer((props: AddButtonProps) => {
	const cn = classnames('add-button', props.containerClass);
	return (
		<AntButton
			icon={<PlusCircleOutlined />}
			className={cn}
			title={props.label}
			onClick={props.onClick}
			disabled={props.disabled}
			type={'text'}
		/>
	);
});
